import { ArticlesProvider, useArticles } from "../../ContextData/ContextData";
import { sectionTitle } from "../Home/Header_Utils/header_utils";
import "./FooterTop.scss";
import { Link } from "react-router-dom";


function FooterTop() {
  return (
    <header className="header">
      <div>
        {sectionTitle(
          "Ready to Transform Your Future?",
          `Join thousands of young African farmers who are building sustainable agricultural businesses and creating
          positive change in their communities. Your journey starts here.`
        )}
        <div className="header-content">
          <div>
            <Link to="/contact" className="button button-primary">
              Join AFRIYOFA Today
            </Link>
            <Link to="/about" className="button button-secondary">
              Learn More About Us
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

 function FooterBottom({contacts}) {
  const { email, phone, facebook, twitter, instagram, linkedin } = contacts || {};
    const logo = <img src={"https://res.cloudinary.com/dpal9vr21/image/upload/v1764849012/kb6smqkbp9aigweg12dx.png"} border='0' alt='afrifoya-logo'></img>
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="logo-section">
            <div className="logo">
              {logo}
            </div>
            <p>
              Empowering African youth through sustainable agriculture and
              innovative farming practices. Building a future where young
              farmers thrive and communities prosper.
            </p>
            <div className="social-icons">
              <Link to={facebook || ""}>
                <i className="ri-facebook-fill"></i>
              </Link>

              <Link to={twitter || ""}>
                <i className="ri-twitter-x-fill"></i>
              </Link>

              <Link to={instagram || ""}>
                <i className="ri-instagram-line"></i>
              </Link>
              <Link to={linkedin || ""}>
                <i className="ri-linkedin-box-fill"></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <nav className="footer-nav">
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact</Link>
          </nav>
        </div>
        <div className="footer-section">
          <h3>Contact Info</h3>
          <div className="contact-info">
            <div className="contact-item">
              <i className="ri-map-pin-line"></i>
              <span>Kampala, Uganda</span>
            </div>
           
            <div className="contact-item">
              <i className="ri-phone-line"></i>
              <span>{phone || "+256 779 135 953"}</span>
            </div>
            <div className="contact-item">
              <i className="ri-mail-line"></i>
              <span>{email || "info@afriyofa.com"}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

const Footer = () => {
  const { contacts } = useArticles();
  return (
    <div>
      <FooterTop />
      <FooterBottom contacts={contacts} /> 
    </div>
  );
};

const FooterProvider = ()=> <ArticlesProvider>
  <Footer/></ArticlesProvider>

export default FooterProvider
